import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

import Signup from "./Signup";
import { AuthProvider } from "../contexts/AuthContext";
import { ModalProvider } from "../contexts/ModalContext";

import Home from "./Home";
import About from "./About";
import Contact from "./Contact";
import Dashboard from "./Dashboard";
import ReportDemo from "./ReportDemo";
import Login from "./Login";
import PrivateRoute from "./PrivateRoute";
import ForgotPassword from "./ForgotPassword";
import Error from "./Error";
import Profile from "./Profile";
import UpdateProfile from "./UpdateProfile";
import Navbar from "./Navbar/Navbar";
import Privacy from "./Privacy";
import Imprint from "./Imprint";
import Footer from "./Footer";

import ScrollToTop from "./ScrollToTop";

function App() {
  return (
    <Router>
      <AuthProvider>
        <ModalProvider>
          <header>
            <Navbar />
          </header>
          <main className="main-content">
            <ScrollToTop />
            <Switch>
              <Route exact path="/" component={Home} />
              <PrivateRoute path="/dashboard" component={Dashboard} />
              <Route path="/dashboard-demo" component={ReportDemo} />
              <Route path="/about" component={About} />
              <Route path="/contact" component={Contact} />
              <Route path="/login" component={Login} />
              <Route path="/signup" component={Signup} />
              <Route path="/forgot-password" component={ForgotPassword} />
              <Route path="/privacy" component={Privacy} />
              <Route path="/imprint" component={Imprint} />
              <PrivateRoute path="/profile" component={Profile} />
              <PrivateRoute path="/update-profile" component={UpdateProfile} />
              <Route path="*" component={Error} />
            </Switch>
          </main>
          <footer>
            <Footer />
          </footer>
        </ModalProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
